import { Layout } from 'components/index';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { DashboardTabState } from 'types/enums/DashboardTabState';
import ToDoTab from './DashboardTabs/ToDoDashboard/ToDoTabScreen';
import KpiMetricsTab from './DashboardTabs/KpiMetricsTab';
import DashboardTabs from './DashboardTabs/DashboardTabs';
import TabContext from '@mui/lab/TabContext/TabContext';
import { useAppState } from 'store/Provider';
import TabPanel from '@mui/lab/TabPanel';

const DashboardPage: React.FC<RouteComponentProps> = ({ match }) => {
  const { state } = useAppState();

  return (
    <Layout name="Dashboard" path="" isWelcome>
      <TabContext value={state.dashboard.pageHandler.parentTab}>
        <DashboardTabs currentToAssignCount={0} />
        <TabPanel sx={{ p: 1 }} value={DashboardTabState.TODO}>
          <ToDoTab />
        </TabPanel>
        <TabPanel sx={{ p: 1 }} value={DashboardTabState.KPI_METRICS}>
          <KpiMetricsTab />
        </TabPanel>
      </TabContext>
    </Layout>
  );
};

export default DashboardPage;
